import "./section2.css";
import CardsDefault from "../cardsDefault/cardDefault";

function Sections({ Titulo }) {
  return (
    <div className="Sections mtb-70 ">
      <div className="container">
        <div className="row">
          <CardsDefault
            titulo={"Compre"}
            texto={
              'Escolha o tipo de Certificado Digital (e-CNPJ, e-CPF ou NF-e), selecione o tempo de utilização e clique no botão "Comprar Certificado".'
            }
            img={"https://sinpejus.ctplus.com.br/images/ico_comprar1.png"}
          />
          <CardsDefault
            titulo={"Emita"}
            texto={
              "Após a confirmação do pagamento, você pode agendar o atendimento (presencial ou videoconferência), para a emissão do Certificado. Deixe tudo preparado e os documentos organizados."
            }
            img={"https://sinpejus.ctplus.com.br/images/ico_comprar2.png"}
          />
          <CardsDefault
            titulo={"Instale"}
            texto={
              "O protocolo pode ser validado antes de 24 horas ou em até 72 horas. Após a liberação, um e-mail será enviado com as informações sobre a instalação."
            }
            img={"https://sinpejus.ctplus.com.br/images/ico_comprar3.png"}
          />
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <h2 className="section-title">{Titulo}</h2>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sections;
